// extracted by mini-css-extract-plugin
export default {"buttons":"NavbarButtons_buttons__num0Z"};